import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Uploads file instructions
 * @param file The file being uploaded
 * @returns Response indicating success and the id of the newly created instruction
 */
export function postInstructionFile(this: unknown, file: FormData) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          miEnvironment.resolve(this).instructionFileUrl
        }?description=partnerfile`,
        {
          method: 'POST',
          headers: {
            // Uploading form data. `requiredHeaders` is not needed.
            ...jwtAuthHeaders,
          },
          body: file,
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        id: z.string(),
        name: z.string(),
        description: z.string(),
        timestamp: z.string(),
      })
    )
  );
}
